import { render, staticRenderFns } from "./ChildSelectorAttribute.vue?vue&type=template&id=2a4bc21d"
import script from "./ChildSelectorAttribute.vue?vue&type=script&lang=js"
export * from "./ChildSelectorAttribute.vue?vue&type=script&lang=js"
import style0 from "./ChildSelectorAttribute.vue?vue&type=style&index=0&id=2a4bc21d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports